import { PropsWithChildren, useState } from 'react';
import { FormCheckboxField, LocalizedText, lt } from '@mews/framework';
import { Grid, GridItem, Link, Stack, StackItem, Typography } from '@optimus-web/core';
import { UnicodeEntity } from '@mews/enums';
import { TextKey } from '@mews-commander/enums';
import { PaymentsConfigurationFieldName } from '../../types';
import { TermsAndConditionsDialog } from '../TermsAndConditionsDialog';

export const CardSharingCheckbox = ({ children }: PropsWithChildren<{}>) => {
    const [isDialogActive, setIsDialogActive] = useState(false);
    return (
        <>
            <FormCheckboxField name={PaymentsConfigurationFieldName.IsCardSharingEnabled} size="medium">
                <Stack spacing="200" vertical>
                    <StackItem>
                        <Typography textStyle="bodyLargeStrong" as="div">
                            {lt('PaymentsConfigurationCardSharingCheckboxLabel')}
                            {UnicodeEntity.Space}
                            {UnicodeEntity.Dagger}
                        </Typography>
                        <Typography textStyle="bodyLarge" as="div">
                            {lt('PaymentsConfigurationCardSharingCheckboxDescription')}
                        </Typography>
                    </StackItem>
                    <StackItem>
                        <Typography textStyle="bodyLarge" as="div">
                            {lt('PaymentsConfigurationCardSharingAffectedProperties')}
                        </Typography>
                        {children}
                    </StackItem>
                    <StackItem>
                        <Grid templateColumns="auto auto" gap="50">
                            {UnicodeEntity.Dagger}
                            <Typography textStyle="bodyLarge" as="div">
                                <LocalizedText
                                    textKey={TextKey.PaymentsConfigurationTermsAndConditionsLinkPrompt}
                                    substitutes={{
                                        a: (text) => <Link onClick={() => setIsDialogActive(true)}>{text}</Link>,
                                    }}
                                />
                            </Typography>
                            <GridItem columnStart="2">
                                <Typography textStyle="bodyLarge" as="div">
                                    {lt('PaymentsConfigurationTermsAndConditionsPrompt')}
                                </Typography>
                            </GridItem>
                        </Grid>
                    </StackItem>
                </Stack>
            </FormCheckboxField>
            <TermsAndConditionsDialog active={isDialogActive} onClose={() => setIsDialogActive(false)} />
        </>
    );
};
